import { Exit, Interactive, Player, Torch } from "../objects";
import { translate } from "../../utils/localization";
import levelDarkKit from "./levelDarkKit";

class Level17 extends levelDarkKit {
  constructor() {
    super();
    this.name = "Into the dark";
    this.diamondsGoal = 10;
  }

  get id() {
    return this.constructor.key;
  }

  async connectToScene(scene) {
    await super.connectToScene(scene);

    if(this.unfinished) {
      this.scene.events.once("player_moves", nextPos => {
        this.detectDocTeleporting(nextPos);
      });
    }
  }

  detectDocTeleporting(nextPos) {
    if (nextPos.y > 45 && this.leader.position.y < 10) {
      this.teleportObject(this.leader, {
        x: this.exit.position.x - 3,
        y: this.exit.position.y,
      });
    } else {
      this.scene.events.once("player_moves", nextPos => {
        this.detectDocTeleporting(nextPos);
      });
    }
  }

  onInteractWith(el) {
    super.onInteractWith(el);

    if (el.isClass(Exit)) {
      this.onComplete();
    }

    if (el.isClass(Interactive) && el.order === 0 && this.unfinished) {
      this.showDialog1();
    }

    if (el.isClass(Interactive) && el.order === 1 && this.unfinished) {
      if (this.collectedDiamonds < this.diamondsGoal) {
        this.showDialogGoal();
      } else {
        this.moveToExit()
        this.interactiveElements[`${el.position.x}-${el.position.y}`] = null
      }
    }
  }

  onAddElement(el) {
    super.onAddElement(el)

    if (el.isClass(Player)) {
      el.power = 1;
      el.hasPickaxe = true;
      // just a hack for presentation before torch is lit
      el.alien.alpha = 0.5;

      this.onNextTick(lvl => {
        if(!lvl.unfinished) {
          el.ligthTorch();
        }
      })
    }

    if (el.isClass(Torch) && el.order === 0) {
      el.ignite();
    }

    if (el.isClass(Interactive) && el.order === 1) {
      el.ephemeral = false;
    }
  }

  showDialog1() {
    this.scene.events.once("dialogue:hidden", () => {
      this.player.ligthTorch();
      this.setTickTimeout(() => {
        this.showDialog2();
      }, 10);
    });
    this.scene.events.emit("dialogue:show", {
      participants: ["closeUp_Dwarf", "closeUp_Mary"],
      participantNames: ["Doc", "Mary"],
      conversation: [
        {
          who: "closeUp_Mary",
          text: [translate("level_17.dialog_1.mary_say_1")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_17.dialog_1.dwarf_say_1")],
        },
      ],
    });
  }
  showDialog2() {
    this.scene.events.emit("dialogue:show", {
      participants: ["closeUp_Dwarf", "closeUp_Mary"],
      participantNames: ["Doc", "Mary"],
      conversation: [
        {
          who: "closeUp_Mary",
          text: [translate("level_17.dialog_2.mary_say_1")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_17.dialog_2.dwarf_say_1")],
        },
      ],
    });
  }
}

Level17.key = "level_17";
export default Level17;
